
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import DialogBranch from './components/DialogBranch.vue';
import { getStatistics, serviceStatisticsListExport } from '@/api/statistics';
import { UserModule } from '../../store/modules/user';
import { IPagination } from '@/types';
@Component({
  name: 'StatisticsServicer',
  components: {
    DialogBranch
  }
})
export default class extends Vue {
  private formSearch = {
    branches: {
      id: -1,
      name: ''
    },
    timePeriods: []
  }
  private orderParams = {
    user_id: UserModule.getUserId,
    company_id: UserModule.getCompanyId,
    page: 1,
    size: 10
  }
  private pickerOptions:any = {
    shortcuts: [{
      text: '今天',
      onClick(picker: any) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); //
        const end = new Date(today); 
        const start = new Date(today); 
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '昨天',
      onClick(picker: any) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); 
        const end = new Date(today); 
        end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
        const start = new Date(today); 
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近7天',
      onClick(picker: any) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); 
        const end = new Date(today); 
        const start = new Date(today); 
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近30天',
      onClick(picker: any) {
     const today = new Date();
        today.setHours(0, 0, 0, 0); 
        const end = new Date(today); 
        const start = new Date(today); 
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        picker.$emit('pick', [start, end]);
      }
    }]
  }

  @Watch('orderParams', { deep: true, immediate: true })
  onParamsChange() {
    // 不在乎哪个变了，只要变了，就要重新请求数据
    this.getList();
  }

  handleCurrentChange(size:number) {
    this.orderParams.page = size;
  }

  handlePageSizeChange(size: number) {
    this.orderParams.size = size;
  }

  private pagination: IPagination = {
    currentPage: 1,
    pageSize: 1,
    total: 0
  }
  private branchVisible = false
  selectBranchHandle() {
    this.branchVisible = true;
  }
  closeBranchHandle(value: boolean) {
    this.branchVisible = value;
  }

  private loading = false
  private tableData = []
  private selectedData: string[] = [];
  handleSelected(val:any[]) {
    this.selectedData = [];
    for (const item of val) {
      this.selectedData.push(item.servicer_company_id);
    }
  }
  // 导出Excel
  handleExport() {
    let servicerCompanyIds = this.selectedData.join(',');
    if (servicerCompanyIds === '') {
      const msg = '请先选择要导出的服务方';
      this.showErrorMsg(msg);
      return false;
    }
    let startTime: any = this.formSearch.timePeriods ? Date.parse(this.formSearch.timePeriods[0]) / 1000 : '';
    let endTime: any = this.formSearch.timePeriods ? Date.parse(this.formSearch.timePeriods[1]) / 1000 : '';
    let pamars:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      user_name: UserModule.getUserName,
      company_name: UserModule.getCompanyName,
      servicer_company_id: servicerCompanyIds,
      start_time: isNaN(startTime) ? '' : startTime,
      end_time: isNaN(endTime) ? '' : endTime
    };
    serviceStatisticsListExport(pamars).then(res => {
      this.$confirm('是否跳转下载页面？', '跳转', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let routeData = this.$router.resolve({
          path: '/ExportTask',
          query: {}
        });
        window.open(routeData.href);
      }).catch(() => {

      });
    }).catch(err => {
      let msg = err.msg;
    });
  }

  created() {
    this.cid = this.$route.query.cid as string;
    this.sid = this.$route.query.sid as string;
    this.getList();
  }

  getList() {
    /**
     * @apiParam {Number} user_id 用户id
     * @apiParam {Number} company_id 公司id
     * @apiParam {Number} branch_company_id 分公司id
     * @apiParam {Number} start_time 开始时间
     * @apiParam {Number} end_time 结束时间
     * @apiParam {Number} cid 点击查询的那条公司id
     * @apiParam {Number} sid 点击查询的那条服务方id
     */
    let startTime: any = this.formSearch.timePeriods ? Date.parse(this.formSearch.timePeriods[0]) / 1000 : '';
    let endTime: any = this.formSearch.timePeriods ? Date.parse(this.formSearch.timePeriods[1]) / 1000 : '';
    let branchCompanyId = this.formSearch.branches.id === -1 ? '' : this.formSearch.branches.id;
    // eslint-disable-next-line camelcase
    let params = {
      ...this.orderParams,
      cid: this.cid,
      sid: this.sid,
      branch_company_id: branchCompanyId,
      start_time: isNaN(startTime) ? '' : startTime,
      end_time: isNaN(endTime) ? '' : endTime
    };
    this.loading = true;
    getStatistics(params).then(res => {
      if (res && res.data) {
        this.pagination.currentPage = parseInt(res.data.page_current);
        this.pagination.total = parseInt(res.data.count);
        this.pagination.pageSize = parseInt(res.data.page_size);
        this.tableData = res.data.list;
      } else {
        this.pagination.currentPage = 1;
        this.pagination.total = 0;
        this.tableData = [];
      }
      this.loading = false;
    }).catch(err => {
      let msg = err.msg;
      this.tableData = [];
      this.loading = false;
    });
  }

  handleDetails(row: any) {
    this.$router.push({
      path: 'details',
      query: {
        servicer_company_id: row.servicer_company_id
      }
    });
  }

  private cid: string = '';
  private sid: string = ''

  branchStat(row: any) {
    this.$router.push({
      path: 'branch',
      query: {
        branch_company_id: row.customer_company_id,
        servicer_company_id: row.servicer_company_id
      }
    });
  }

  handleSelectedBanch(row: any) {
    this.branchVisible = false;
    this.formSearch.branches.id = row.id;
    this.formSearch.branches.name = row.name;
  }

  handleSearch() {
    this.pagination.currentPage = 1;
    this.getList();
  }

  handleClear() {
    this.formSearch = {
      branches: {
        id: -1,
        name: ''
      },
      timePeriods: []
    };
    this.pagination.currentPage = 1;
    this.pagination.total = 0;
    this.getList();
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
}
